import { useState, useEffect, Fragment } from "react";
import dynamic from "next/dynamic";
import { motion } from "framer-motion";
import parse from "html-react-parser";
import { dehydrate, QueryClient, useQuery } from '@tanstack/react-query';
import { getQueryFn, queryKeyManager } from "../../../utils/api/queryFunction";
import queryConfig from "../../../utils/api/queryConfig";
import { hasProperty } from "../../../utils/validate";

const SEO = dynamic(() => import("../../../components/Shared/SEO"));
const ProductLayout = dynamic(() => import('../../../components/Layout/ProductLayout'));
const SmallBanner = dynamic(() => import('../../../components/Shared/Banners/SmallBanner'));
const FormBuilder = dynamic(() => import("../../../components/Shared/FormBuilder"));

const endpoint = 'motorcycles/bas';

const BASPage = props => {
	const { token } = props;
	const { isLoading, isError, data } = useQuery({
		queryKey: queryKeyManager(['motorcycles', 'book-a-service'], [token]),
		queryFn: () => getQueryFn(`${endpoint}`, token),
		...queryConfig
	})

	if (isLoading) {
		return <span />
	}

	if (hasProperty(data, 'error') || isError){
		return <Error error={data.error} errorCode={data.error.code}  />
	}

	const [showTY, setShowTY] = useState(false);
	const [formData, setFormData] = useState();

	useEffect(() => {
		async function getFormData() {
			if (hasProperty(data, "form") && data.form != null && data.form.handle) {
				let formResponse = await getQueryFn(`form/${data.form.handle}`);
				setFormData(formResponse);
			}
		}
		getFormData();
	}, [data]);

	const submitData = (success) => {
		if (success) {
			window.location.href = '/motorcycles/book-a-service/thank-you';
		} else {
			alert("oops, something went wrong. Please try again later");
		}
	};

	const form = {
		open: {
			height: "auto"
		},
		close: {
			height: "0"
		}
	};

	const thankYou = {
		open: {
			height: "auto"
		},
		close: {
			height: "0"
		}
	};

	return (
		<Fragment>
			<SEO seo={data.seo} />
			<ProductLayout nav={data.nav.header.links} logo={data.nav.header.logos.motorcycles} root="motorcycles" footer={data.nav.footer}>
				<SmallBanner banner={data.banner} />
				<div className="customContainer mt64px requestAPart">
					<motion.div
						initial="open"
						animate={!showTY ? "open" : "close"}
						variants={form}
						className="formHolder"
					>
						<div className="row">
							<div className="col s12 m12 l12 introDescription">
								{data.introDescription ? parse(data.introDescription) : ''}
							</div>
						</div>
						{formData &&
							<FormBuilder
								formData={formData}
								handleSubmit={submitData}
								category={data.category}
								maxSpan="8"
								spec={data.dealerSpec}
							/>
						}
					</motion.div>
					<motion.div
						className="thankYou"
						initial="close"
						animate={showTY ? "open" : "close"}
						variants={thankYou}
					>
						<div className="row">
							<div className="col s12 m6 l4">
								<h5 className="thankYouTitle">
									Thank you for contacting with Honda!
								</h5>
							</div>
							<div className="col s12 m6 l4 thankYouDesc">
								<p>
									Your preferred Honda Dealer will be in touch soon.
								</p>
							</div>
						</div>
					</motion.div>
				</div>
			</ProductLayout>
		</Fragment>
	);
};

BASPage.getInitialProps = async ({ query, req }) => {
	const queryClient = new QueryClient();
	const { token } = query;
	await queryClient.prefetchQuery({
		queryKey: queryKeyManager(['motorcycles', 'book-a-service'], [token]),
		queryFn: () => getQueryFn(`${endpoint}`, token),
		...queryConfig
	});
	return {
		token: token,
		dehydratedState: dehydrate(queryClient)
	};
};

export default BASPage;
